import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export type PlanDisplayStatus =
	| 'none'
	| 'active'
	| 'pending'
	| 'payment_failed'
	| 'wait_cancel'
	| 'canceled'
	| 'disabled';

export interface PlanSummaryPlan {
	_id: string;
	name: string;
	description?: string;
	price: number;
	interval: string;
	intervalCount: number;
	advantages: string[];
	maxProps: number;
	maxSamples: number;
	paymentMethods: string[];
	hierarchy?: {
		role?: string | null;
		name?: string | null;
	} | null;
}

export interface PlanSummaryUsage {
	used: number;
	max: number;
}

export interface PlanSummaryResponse {
	plan: PlanSummaryPlan | null;
	canUpgrade: boolean;
	upgradePlanName: string | null;
	status: string | null;
	paymentStatus: string | null;
	displayStatus: PlanDisplayStatus;
	waitCancel: boolean;
	paymentMethod: string | null;
	signedAt: string | null;
	expiresIn: string | null;
	cycleStart: string | null;
	usage: {
		props: PlanSummaryUsage;
		samples: PlanSummaryUsage;
	};
	nextCharge: {
		amount: number;
		date: string | null;
	} | null;
	billing: {
		document: string | null;
		documentType: string | null;
		receiptUrl: string | null;
	};
}

export function useGetPlanSummary(enabled = true) {
	const query = useQuery<PlanSummaryResponse>({
		queryKey: ['user-plan-summary'],
		queryFn: async () => {
			const { data } = await api.get<PlanSummaryResponse>('/user/plan/summary');
			return data;
		},
		enabled,
	});

	return {
		...query,
		data: query.data ?? null,
	};
}
